/**
 * PROD-3195. The patient's ambient-recording consent, as the encounter checks it when it opens
 * (`GET api/Consent/AmbientRecording/Status`, Scrips.Patient PROD-2683).
 *
 * This check is UX only. Video still enforces consent at session start, and everything the panel
 * does after a Start (the `consent-denied` ack, `endForConsent`, `consent-refusal-copy.ts`) stays.
 *
 *   checking : the first answer is not in yet. Start is disabled, a short status line shows.
 *   granted  : Start is enabled, as before.
 *   denied   : Start is disabled and the panel says why, with a way to sign the consent now.
 *   unknown  : the check failed (network, 5xx) or answered something this client does not know.
 *              Start is ENABLED and no denial copy shows: a failed pre-check must not stop a
 *              consultation the server would allow. The server decides at Start.
 */
export type RecordingConsentStatus = 'checking' | 'granted' | 'denied' | 'unknown';

/** What the panel needs from the host. Optional on the panel: absent = no pre-check, as before. */
export interface RecordingConsentPort {
  status: RecordingConsentStatus;
  /** Opens the host's consent signing flow. The host re-checks after a signature and the status moves on. */
  onSignNow: () => void;
}

/** The exact words shown when the patient has not consented (Samer, via Andrew). */
export const RECORDING_CONSENT_DENIED_COPY = "This account cannot be recorded. Patient didn't sign consent.";
export const RECORDING_CONSENT_CHECKING_COPY = 'Checking recording consent…';
